import { render } from "./FolderBox.vue?vue&type=template&id=990b7bd8"
import script from "./FolderBox.vue?vue&type=script&lang=js"
export * from "./FolderBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__